<div class="photo_gallery header_top my-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_1.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_2.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_3.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_4.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_5.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_6.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_7.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_8.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_9.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_10.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_11.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_12.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_13.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_14.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_15.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_16.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_17.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_18.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_19.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_20.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_21.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_22.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_23.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_24.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_25.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_26.webp" alt=""></div>
            <div class="col-lg-4 col-md-4 col-sm-12"><img loading="lazy"
                    src="../../../assets/images/photo_gallery/ncare_img_27.webp" alt=""></div>
        </div>
    </div>
</div>